var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.tools && _vm.$mq != 'mobile'
            ? 'paragrapheEditorTools'
            : 'paragrapheEditor',attrs:{"id":"paragraphEditor"}},[_c('div',{ref:"editor",attrs:{"id":"quill_editor"}}),(this.limit)?_c('div',{attrs:{"id":"counter"}},[_vm._v(" "+_vm._s(_vm.$t("rapportedit.sections.size_limit_indicator", {nb_chars: this.nbCharacters, limit: this.limit}))+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }